import * as React from 'react';
import { ServiceView } from 'elc-service';
import { PRODUCT_NOTIFY_ME } from 'elc-service-view-names';
import { IWaitlist } from '../../../exported/product-cta/ProductCTA';
import { Sku } from '../../domain/entities/Sku';
import { InventoryStatus } from '../../constants/InventoryStatuses';
import {
    BACK_IN_STOCK_SUBSCRIPTION,
    COMING_SOON_SUBSCRIPTION
} from '../../constants/SubscriptionTypes';

export interface IMapping {
    [key: string]: string;
}

export interface IProductNotifyMeCTA {
    selectedSku: Sku;
    config: {
        enableNotifyMe?: boolean;
        waitlist?: IWaitlist;
        compliance?: { gdpr: boolean };
        customNotifyMeLabel?: string;
        ctaType?: string;
    };
}

interface IProductNotifyMeConfig {
    productDisplayName: string;
    productUrl: string;
    productImageUrl: string;
    skuId: string;
    subscriptionType: string;
    altText: string;
    compliance?: { gdpr: boolean };
    enableNotifyMe?: boolean;
    waitlist?: IWaitlist;
    skuBaseId: number;
    zIndex: string;
    customNotifyMeLabel?: string;
    ctaType?: string;
}

export class NotifyMeCTA extends React.Component<IProductNotifyMeCTA> {
    private notifyMeSubscriptionType(inventoryStatus: string) {
        const subscriptionTypes: IMapping = {
            [InventoryStatus.TempOutOfStock]: BACK_IN_STOCK_SUBSCRIPTION,
            [InventoryStatus.ComingSoon]: COMING_SOON_SUBSCRIPTION
        };

        return subscriptionTypes[inventoryStatus] || '';
    }

    public render() {
        const { config, selectedSku } = this.props;
        const { enableNotifyMe, waitlist, compliance, customNotifyMeLabel, ctaType } = config;

        const {
            skuId,
            partialParentProduct,
            inventoryStatus,
            perlgem: { SKU_BASE_ID }
        } = selectedSku;

        const { displayName, productUrl } = partialParentProduct;

        const notifyMeConfig: IProductNotifyMeConfig = {
            productDisplayName: displayName,
            productUrl: productUrl,
            productImageUrl: partialParentProduct.defaultImage.src,
            skuId: skuId,
            subscriptionType: this.notifyMeSubscriptionType(inventoryStatus),
            altText: partialParentProduct.defaultImage.alt,
            compliance,
            enableNotifyMe,
            waitlist,
            skuBaseId: SKU_BASE_ID,
            zIndex: '100001',
            customNotifyMeLabel,
            ctaType
        };

        return <ServiceView name={PRODUCT_NOTIFY_ME} config={notifyMeConfig} />;
    }
}
